// export const DownloadPdfEndPoint = 'https://reports.opptimise.in/'
// export const DownloadPdfEndPoint = 'http://reports-uat.opptimise.in/'
// export const DownloadPdfEndPoint = 'https://opptimise-reports-uat.pacewisdom.in/'
export const BackendEndPoint = 'https://api.opptimise.in/api/v1/'
export const DownloadPdfEndPoint = 'https://reports.opptimise.in/'



// WEBPACK FOOTER //
// ./src/_pages/DashBoard/viewReport/DownloadPdfEndPoint.js